import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component, Fragment } from 'react';
import { List, Map, Repeat } from 'immutable';
export var AttributesField = /*#__PURE__*/function (_Component) {
  _inherits(AttributesField, _Component);

  var _super = _createSuper(AttributesField);

  function AttributesField(props) {
    var _this;

    _classCallCheck(this, AttributesField);

    _this = _super.call(this, props);

    _this.countPrevious = function (name) {
      return _this.props.value.get(name).size - _this.countAdded(name);
    };

    _this.countAdded = function (name) {
      return _this.state.added.filter(function (n) {
        return n === name;
      }).size;
    };

    _this.onRemove = function (name, index) {
      return function () {
        var addedIndex = index - _this.countPrevious(name);

        if (addedIndex >= 0) {
          _this.setState(function (state) {
            return {
              added: filterWithOccurrences(state.added, function (n, i) {
                return n !== name || i !== addedIndex;
              })
            };
          });
        }

        _this.props.onChange(_this.props.value.deleteIn([name, index]));
      };
    };

    _this.onInputChange = function (name, index) {
      return function (event) {
        var value = event.target.value;

        if (!_this.props.value.hasIn([name, index])) {
          _this.setState(function (state) {
            return {
              added: state.added.push(state.adding),
              adding: ''
            };
          });
        }

        _this.props.onChange(_this.props.value.update(name, List(), function (values) {
          return values.set(index, value);
        }));
      };
    };

    _this.onSelectChange = function (event) {
      _this.setState({
        adding: event.target.value
      });
    };

    _this.state = {
      added: List(),
      adding: ''
    };
    return _this;
  } // returns the number of attribute values that were previously set


  _createClass(AttributesField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var attributes = mapWithOccurrences(this.props.value.keySeq().sort().flatMap(function (name) {
        return Repeat(name, _this2.countPrevious(name));
      }).concat(this.state.added.push(this.state.adding)), function (name, index) {
        return {
          name: name,
          index: index,
          value: _this2.props.value.getIn([name, index], '')
        };
      });
      return this.props.visible && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h5", null, this.props.label), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Value"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, attributes.size === 1 && this.props.placeholder && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: 3
      }, /*#__PURE__*/React.createElement("em", null, this.props.placeholder))), attributes.map(function (_ref, i) {
        var name = _ref.name,
            value = _ref.value,
            index = _ref.index;
        return /*#__PURE__*/React.createElement("tr", {
          key: i
        }, /*#__PURE__*/React.createElement("td", null, i < attributes.size - 1 ? name : /*#__PURE__*/React.createElement("select", {
          onChange: _this2.onSelectChange,
          value: name
        }, /*#__PURE__*/React.createElement("option", {
          hidden: true
        }), availableAttributes(_this2.props.options, _this2.props.value).map(function (option) {
          return /*#__PURE__*/React.createElement("option", {
            key: option,
            value: option
          }, option);
        }))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
          type: "text",
          value: value,
          onFocus: _this2.props.onFocus,
          onBlur: _this2.props.onBlur,
          onChange: _this2.onInputChange(name, index)
        })), /*#__PURE__*/React.createElement("td", null, i < attributes.size - 1 && /*#__PURE__*/React.createElement("button", {
          type: "button",
          onFocus: _this2.props.onFocus,
          onBlur: _this2.props.onBlur,
          onClick: _this2.onRemove(name, index)
        }, "\xD7")));
      }))));
    }
  }]);

  return AttributesField;
}(Component); // Helper function that maps for a List but instead of providing the index in
// the overall list, it gives the lambda the count of the occurrences of current
// value that have already occurred in the list.
// For example: ['red', 'green', ''red',]
// Would call: ['red,' 0], ['green', 0], ['red', 1], ['blue', 0]

var mapWithOccurrences = function mapWithOccurrences(list, mapper) {
  return list.reduce(function (_ref2, current) {
    var _ref3 = _slicedToArray(_ref2, 2),
        result = _ref3[0],
        counts = _ref3[1];

    return [result.push(mapper(current, counts.get(current, 0))), counts.update(current, 0, function (count) {
      return count + 1;
    })];
  }, [List(), Map()])[0];
}; // Same idea as mapWithOccurrences above.


var filterWithOccurrences = function filterWithOccurrences(list, pred) {
  return list.reduce(function (_ref4, current) {
    var _ref5 = _slicedToArray(_ref4, 2),
        result = _ref5[0],
        counts = _ref5[1];

    return [pred(current, counts.get(current, 0)) ? result.push(current) : result, counts.update(current, 0, function (count) {
      return count + 1;
    })];
  }, [List(), Map()])[0];
};

var availableAttributes = function availableAttributes(options, value) {
  return options.filter(function (option) {
    return option.get('allowsMultiple') || value.get(option.get('name'), List()).isEmpty();
  }).map(function (option) {
    return option.get('name');
  });
};